<template>
  <BaseRadiolist
    v-bind="$attrs"
    v-model="modelValue"
    :options="BDX_CURRENCY_TYPES"
    label="Currency"
    :searchable="false"
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BDX_CURRENCY_TYPES } from '@constants'
import { BaseRadiolist } from '@components/base'

export default defineComponent({
  name: 'BDXWizardCurrencies',
  components: {
    BaseRadiolist
  },
  props: {
    value: String
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      BDX_CURRENCY_TYPES,

      modelValue
    }
  }
})
</script>
